function getCardBrand(brand) {
  switch (brand) {
    case 'amex':
      return 'American Express';
    case 'mastercard':
      return 'MasterCard';
    case 'jcb':
      return 'JCB';
    case 'visa':
      return 'Visa';
    default:
      return brand;
  }
}

export default getCardBrand;
// , Diners Club, Discover, , , UnionPay,
